import React from "react";

type Props = {
    brand: string;
};

export const CreditCardBrandIcon: React.FC<Props> = (props) => {
    let icon = "";

    switch (props.brand.toLowerCase()) {
        case "visa":
            icon = "cc-visa";
            break;

        case "mastercard":
            icon = "cc-mastercard";
            break;

        case "amex":
            icon = "cc-amex";
            break;

        case "discover":
            icon = "cc-discover";
            break;

        case "jcb":
            icon = "cc-jcb";
            break;

        case "unionpay":
            icon = "cc-stripe";
            break;

        default:
            // Brands without a Font Awesome logo (diners, eftpos, unknown, ...) get the generic card.
            return <i className={"fas fa-credit-card"}></i>;
    }

    return <i className={`fa-brands fa-${icon}`}></i>;
};
